/**
 * ロケーション（ピン）データを統一された形式にフォーマットする
 * @param {Object} location - ロケーションオブジェクト
 * @returns {Object} フォーマットされたピンオブジェクト
 */
export const formatPin = (location) => ({
    id: location.id,
    title: location.title,
    // description は一覧APIに含まれないため、単件取得時のみセットされる
    description: location.description ?? null,
    position: {
        lat: location.latitude,
        lng: location.longitude,
    },
    creatorId: location.user_id,
    creatorName: location.user,
    createdAt: location.created_at,
    labelId: location.label,
    thumbnail: location.thumbnail,
    thumbnail_url: location.thumbnail_url || null,
});

// 後方互換性のため、formatLocationもエクスポート
export const formatLocation = formatPin;